import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { reactIcons } from "../utils/icons";
import { useSelector } from "react-redux";

const Dashboard = () => {
  const [isOpen, setIsOpen] = useState(false);
  const user = useSelector((state) => state.auth.user);
  return (
    <div className=" min-h-screen w-full bg-[#00140B] ">
      <div
        className={`${
          isOpen ? "left-[-100%]" : "left-0"
        } xl:w-[280px] w-[200px] flex xxl:w-[250px]  h-full transition-all duration-300 flex-shrink-0 fixed  top-0 z-50 `}
      >
        <Sidebar setIsOpen={setIsOpen} />
      </div>
      <div
        className={`pb-6 transition-all duration-300 ${
          isOpen
            ? "ml-0"
            : " ml-[200px] xl:ml-[280px] xxl:ml-[250px] w-[calc(100%-200px)]  xl:w-[calc(100%-280px)] xxl:w-[calc(100%-250px)] "
        }`}
      >
        <nav className="  text-grey-90 w-full py-6 xxl:py-6 sticky left-0 top-0 z-50 shadow-sm px-8  bg-[#00140B] gradient-border-bottom ">
          <div className="flex items-center gap-2">
            {isOpen && (
              <button
                onClick={() => setIsOpen(false)}
                className="w-10 h-10 flex-center bg-custom-gradient rounded-full text-3xl"
              >
                {reactIcons.arrowright}
              </button>
            )}
            <h4 className=" text-24 text-white">
              Hii, {user?.fullname || "Admin"}
            </h4>
          </div>
        </nav>
        <div className="px-6 w-full  bg-[#00140B] pt-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
